const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export { INDIAN_STATES };

// Stored billing address is one line: "street, city, State PIN".
// Split it back so an existing address can be edited field by field.
export function parseSavedBillingAddress(raw: string) {
  const address = raw.trim();
  const pinMatch = address.match(/([1-9][0-9]{5})\s*$/);
  const pinCode = pinMatch?.[1] ?? "";
  let rest =
    pinMatch?.index != null
      ? address.slice(0, pinMatch.index).trim().replace(/,\s*$/, "")
      : address;
  const stateName =
    [...INDIAN_STATES]
      .sort((a, b) => b.length - a.length)
      .find((name) => rest.endsWith(name)) ?? "";
  if (stateName) {
    rest = rest.slice(0, -stateName.length).trim().replace(/,\s*$/, "");
  }
  const comma = rest.lastIndexOf(",");
  if (comma === -1) {
    return { line1: rest, city: "", stateName, pinCode };
  }
  return {
    line1: rest.slice(0, comma).trim(),
    city: rest.slice(comma + 1).trim(),
    stateName,
    pinCode,
  };
}
